/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config.
   * Falls back to the fork brand "Kosmos-chat" if installation name is missing,
   * so user-facing copy never leaks the upstream brand.
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName =
      globalConfig.value?.installationName || 'Kosmos-chat';

    return text.replace(/Chatwoot/g, installationName);
  };

  return {
    replaceInstallationName,
  };
}
